import { defineSlotRecipe } from '@chakra-ui/react';

/** Toast surface. Type colors from Chakra still apply on top of this shell. */
export const toastSlotRecipe = defineSlotRecipe({
  slots: ['root', 'title', 'description'],
  base: {
    root: {
      bg: 'surface',
      color: 'text',
      borderWidth: 'hairline',
      borderColor: 'border',
      borderRadius: 'lg',
    },
    title: {
      color: 'text',
    },
    description: {
      color: 'textMuted',
    },
  },
});
